import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import { ErrorFallback } from './components/ErrorFallback';
import { initSentry } from './lib/sentry';
import './index.css';

// Initialize Sentry BEFORE React renders so init-time errors are captured too.
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={(props) => <ErrorFallback resetError={() => props.resetError()} />}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
